import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TrainingItemGroup } from '../models/training-item-group';
import { Observable, of, tap } from 'rxjs';
import { ApiConstants } from '../../../app/shared/constants/api-constants';
import { ITrainingItemGroupDetails } from '../models/training-item-group-details';
import { TrainingItemGroupSearchCriteria } from '../../training-item-group-search/models/training-item-group-search-criteria';
import { IEQMSScopeLookUpDetails } from '../../shared/models/scopes/eqms-Scope-lookup-details';
import { EQMSScopeHierarchy } from '../../shared/models/scopes/eqms-scope-hierarchy';
import { TrainingItemDocumentPayload } from '../models/training-item-document-payload';

@Injectable({
  providedIn: 'root'
})
export class TrainingItemGroupService {
  eQMSScopesForTrainingItemGroupSearch: IEQMSScopeLookUpDetails[] = [];
  eQMSScopesForTrainingItemGroup: IEQMSScopeLookUpDetails[] = [];
  treeData:EQMSScopeHierarchy = {} as EQMSScopeHierarchy;
  constructor(private httpClient: HttpClient) { }


  saveTrainingItemGroupDetails(payload: TrainingItemGroup,
    isEditTrainingGroup: boolean): Observable<any> {
    return isEditTrainingGroup ? this.httpClient.put(ApiConstants.TrainingItemGroup_SaveCourseApi, payload)
      : this.httpClient.post(ApiConstants.TrainingItemGroup_SaveCourseApi, payload)
  }

  getLatestDocumentDetail(documentNumberList: string[]): Observable<any> {
    return this.httpClient.post(ApiConstants.Get_List_Of_DocumentLatestVersion_Api, documentNumberList);
  }

  getTrainingItemGroups = (scopeId: number): Observable<ITrainingItemGroupDetails[]> => {
    return this.httpClient.get<ITrainingItemGroupDetails[]>
      (ApiConstants.TrainingItemGroups_Details_Api.replace('{scopeId}', scopeId.toString()))
  }
  getTrainingItemGroup = (trainingItemGroupNumber: string): Observable<ITrainingItemGroupDetails> => {
    return this.httpClient.get<ITrainingItemGroupDetails>
      (ApiConstants.TrainingItemGroup_Details_Api.replace('{trainingItemGroupNumber}', trainingItemGroupNumber))
  }

  getTrainingItemGroupById(id: string): Observable<any> {
    const headers = new HttpHeaders().set('X-No-Retry', 'true');
    return this.httpClient.get(ApiConstants.TrainingItemGroup_ById_Api + `${id}`, { headers: headers });
  }

  searchTrainingItemGroups(trainingItemGroupSearchCriteria: TrainingItemGroupSearchCriteria): Observable<any>{
    return this.httpClient.post(
      ApiConstants.Training_Item_Group_Search_Api, trainingItemGroupSearchCriteria);
  }

  getTrainingItems(trainingItemGroupNumbers : string[]):Observable<any>{
    return this.httpClient.post(ApiConstants.Training_Item_Groups_By_Numbers_Api, trainingItemGroupNumbers);
  }
   
  getEffectiveOrLatestVersionOfDocumentsScheduled(payload: TrainingItemDocumentPayload): Observable<any> {
    return this.httpClient.post<any>(ApiConstants.Get_Documents_With_EffectiveOrLatestVersion_Scheduled_Api, payload);
  }

  getEffectiveOrLatestVersionOfDocuments(documentNumbers: string[]): Observable<any> {
    return this.httpClient.post<any>(ApiConstants.Get_Documents_With_EffectiveOrLatestVersion_Api,documentNumbers);
  }

  getTrainingItemGroupAuthorization(): Observable<any>{
    return this.httpClient.get(ApiConstants.Training_Item_Group_Authorization_Api);
  }

  geteQMSScopesForTrainingItemGroupSearch = (feature:string) => {
    let observable: Observable<IEQMSScopeLookUpDetails[]>;
    if (this.eQMSScopesForTrainingItemGroupSearch.length > 0) {
      observable = of(this.eQMSScopesForTrainingItemGroupSearch);
    }
    else {
      observable = this.httpClient.get<IEQMSScopeLookUpDetails[]>(ApiConstants.EQMSScopesLookupForTrainingItemGroupLibary_Api + "/" + feature)
        .pipe(
          tap(eQMSScopes => this.eQMSScopesForTrainingItemGroupSearch = eQMSScopes)
        );
    }
    return observable;
  }
  geteQMSScopesForTrainingItemGroup = () => {
    let observable: Observable<IEQMSScopeLookUpDetails[]>;
    if (this.eQMSScopesForTrainingItemGroup.length > 0) {
      observable = of(this.eQMSScopesForTrainingItemGroup);
    }
    else {
      observable = this.httpClient.get<IEQMSScopeLookUpDetails[]>(ApiConstants.EQMSScopesLookupForTrainingItemGroup_Api)
        .pipe(
          tap(eQMSScopes => this.eQMSScopesForTrainingItemGroup = eQMSScopes)
        );
    }
    return observable;
  }
  getEQMSScopeForTrainingItemGroupLibrary(): Observable<EQMSScopeHierarchy> {
    let observable: Observable<EQMSScopeHierarchy>;
    if (Object.keys(this.treeData).length > 0) {
      observable = of(this.treeData);
    }
    else {
      observable = this.httpClient.get<EQMSScopeHierarchy>(ApiConstants.EQMSScopesForTrainingItemGroupManagement_Api)
        .pipe(
          tap(treeData => this.treeData = treeData)
        );
    }
    return observable;
  }

  getTrainingItemGroupScopesForTrainingItemGroupNumber(trainingItemGroupNumber : string):Observable<any>{
    return this.httpClient.get(ApiConstants.TrainingItemGroupScopesForTrainingItemNumber_Api.replace('{trainingItemGroupNumber}', trainingItemGroupNumber))
  }
}
